import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import { $, $$, showToast } from '@js/utils';
import './index.scss';

const EventHandler = {};

export default class Slogan {
  constructor(el, name, data = {}) {
    this.el = el;
    const { title, description } = window.store;
    this.shareContent = {
      title: title,
      desc: description,
      link: window.location.href,
      imgUrl: '',
    };
    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);

    // 点击展示全文时触发
    EventEmit.instance.on('showMore', () => {
      const slogan = $('.slogan');
      slogan && slogan.classList.remove('hidden');
    });
  }

  render() {
    this.el.innerHTML = template({
      slogan: 'OPPO 浏览器 · 我的独享世界',
      isHidden: window.store.isShowFold.isShow, // 默认隐藏 点击展开全文时才显示
    });
    EventEmit.instance.emit('component-loaded', 'slogan', {});
  }
}
